var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"class-badge d-flex justify-content-center"},[_c('div',{staticClass:"align-self-center svg-icon",domProps:{"innerHTML":_vm._s(_vm.icons[_vm.memberClass])}})])}
var staticRenderFns = []

export { render, staticRenderFns }